import ScaleService  from './ScaleService';
import AllNotesService from "./AllNotesService";
export default class ChordService {
    _scale = '';

    getFretStart() {
        // Gget a whole number between 0 and 18 (inclusive).
        return Math.floor(Math.random() * 19);
    }

    getScale() {
        return this._scale;
    }

    getSingleNote() {
        let noteArray = this.getTriad('maj_min_dim_triads')
        let note = noteArray[0]
        return [note]
    }

    setScale() {
        let scaleService = new ScaleService();
        let scale = scaleService.chooseRandomScale();
        this._scale = scale.s;
        return scale
    }

    getDoubleScale(scaleData) {
        let doubleScale  = []

        for(let i=0; i<2; i++) {
            for (let j = 0; j < scaleData.n.length; j++) {
                doubleScale.push(scaleData.n[j])
            }
        }
        return doubleScale;
    }
    getDiminishedChordRootIndex(scaleData) {
        if(scaleData.s.includes('minor')) {
            return 1
        }
        return 6
    }

    getRandomSelection(choices) {
        let choiceIndex = Math.floor(Math.random() * 3);
        return choices[choiceIndex]
    }
    getMinorChordRoot(scaleData) {
        if(scaleData.s.includes('minor')) {
            return this.getRandomSelection([0,3,4])
        }
        return this.getRandomSelection([1, 2, 5])
    }

    getMajorChordRoot(scaleData) {
        if(scaleData.s.includes('major')) {
            return this.getRandomSelection([0,3,4])
        }
        return this.getRandomSelection([2,5,6])
    }
    getTriad(chordType) {
        let scaleData     = this.setScale();
        let  startIndex = Math.floor(Math.random() * 7);

        if(chordType==='diminished_triads') {
            startIndex = this.getDiminishedChordRootIndex(scaleData)
        }
        else if(chordType==='major_triads') {
            startIndex = this.getMajorChordRoot(scaleData)
        }
        else if(chordType==='minor_triads') {
            startIndex = this.getMinorChordRoot(scaleData)
        }
        let doubleScale  = this.getDoubleScale(scaleData)

        let middleIndex = startIndex + 2; // regular maj / min triad.

        // https://hubguitar.com/fretboard/sus4-triads
        if(chordType === 'sus2_triads') {
            middleIndex -=1
        }
        else if(chordType==='sus4_triads') {
            middleIndex +=1
        }
        let allNoteService = new AllNotesService();
        let root   = doubleScale[startIndex];
        let second = doubleScale[middleIndex]
        let isHalfStep = allNoteService.isHalfStep(root, second)
        if(isHalfStep) {
            return this.getTriad(chordType)
        }
        let third  = doubleScale[startIndex+4]
        isHalfStep = allNoteService.isHalfStep(second, third)
        if(isHalfStep) {
            return this.getTriad(chordType)
        }

        return [root, second, third]
    }
}
